import axios from 'axios'
import { getEnvironmentURL } from 'utils/getEnvironmentURL'
import { addResponseInterceptor } from './config';

const LanguagesApiService = {}
const baseApiUrlDev = 'https://app-vidsigner-vidcloudmgm-dev.azurewebsites.net/api'
const baseApiUrlPre = 'https://pre-vidsignercloudmgmt.validatedid.com/api'
const baseApiUrlPro = 'https://vidsignercloudmgmt.validatedid.com/api'

LanguagesApiService.baseURL = getEnvironmentURL(baseApiUrlPro, baseApiUrlPre, baseApiUrlPre);

addResponseInterceptor(axios);

LanguagesApiService.getLanguages = (type) => {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem('cloud_token')}` }
  };
  return axios.get(`${LanguagesApiService.baseURL}/v2.0/settings/languages/${type}`, config)
}

export default LanguagesApiService;